export default {
    profile: {
        loading: true,
        data: {
            main: {
                questions :[],
                interests: []
            },
            achievements: []
        }
    }, 
    errors: {},
    editing: false,
    saving: false,
    questions: []
};